export enum SubscriptionPlansInnerNames {
  STARTER = "STARTER",
  GROWTH = "GROWTH",
  PREMIUM = "PREMIUM",
  ENTERPRISE = "ENTERPRISE",
  PREMIUMPLUSFIVE ="PREMIUMPLUSFIVE",
  PREMIUMPLUSTEN ="PREMIUMPLUSTEN",
  PREMIUMPLUSFIFTEEN ="PREMIUMPLUSFIFTEEN",
  PREMIUMPLUSTWENTY ="PREMIUMPLUSTWENTY",
  PREMIUMPLUSTWENTYFIVE ="PREMIUMPLUSTWENTYFIVE",
  PREMIUMPLUSTHIRTY ="PREMIUMPLUSTHIRTY",
  PREMIUMPLUSTHIRTYFIVE="PREMIUMPLUSTHIRTYFIVE",
  PREMIUMPLUSFORTY="PREMIUMPLUSFORTY",
  PREMIUMPLUSFORTYFIVE="PREMIUMPLUSFORTYFIVE",
  PREMIUMPLUSFIFTY="PREMIUMPLUSFIFTY",
}

export type SubscriptionPlanInnerName = keyof typeof SubscriptionPlansInnerNames;
